import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Advantages.css";

import img1 from "../asset/tuition.webp";
import img2 from "../asset/job opp.webp";
import img3 from "../asset/travel.webp";
import img4 from "../asset/culture.webp";
import img5 from "../asset/indus.webp";
import img6 from "../asset/Edu.webp";

const AdvantagesSection = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const advantages = [
    {
      title: "Low Tuition Fees",
      image: img1,
      description:
        "European universities often offer significantly lower tuition fees compared to institutions in other regions, making quality education more accessible.",
    },
    {
      title: "Job Opportunities",
      image: img2,
      description:
        "Studying abroad opens doors to a wide range of job opportunities in various industries. With access to global networks and internships, students gain valuable work experience.",
    },
    {
      title: "Travel",
      image: img3,
      description:
        "Studying in Europe offers the chance to explore diverse cultures, languages, and historical landmarks as well as enjoy different cultures and learn their environment and diversity. This travel exposure broadens horizons and fosters global connections.",
    },
    {
      title: "Culture & Diversity",
      image: img4,
      description:
        "Europe is a melting pot of cultures, offering students the chance to experience rich traditions, performances, architecture, and global understanding.",
    },
    {
      title: "High Demand In Industries",
      image: img5,
      description:
        "European degrees are valued globally, preparing students with practical skills, internships, and a competitive edge to meet industry demands.",
    },
    {
      title: "Education",
      image: img6,
      description:
        "Studying abroad provides access to world-class education, diverse learning environments, and exposure to various cultures for a global perspective.",
    },
  ];

  return (
    <div className="adv-wrapper">
      <h1 className="adv-title Darkerr">Advantages Of Studying In Europe</h1>

      <div className="adv-card-grid">
        {advantages.map((item, index) => (
          <div
            key={index}
            className="adv-card"
            data-aos="fade-up"
            data-aos-delay={index * 100}
          >
            <div className="adv-card-inner">
              <div className="adv-card-image">
                <img src={item.image} alt={item.title} />
              </div>
              <div className="adv-card-heading Darkerr">
                <h1>{item.title}</h1>
              </div>
              <div className="adv-card-desc">
                <p>{item.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdvantagesSection;
